export default "__VITE_ASSET__Cfq9Q3zt__"